import { cn } from '@/core/lib/utils/cn'

type Props = {
  width?: string | number
  height?: string | number
  borderRadius?: string
  count?: number
  className?: string
  marginTop?: string
}

export const Skeleton: React.FC<Props> = ({
  width = '100%',
  height = '20px',
  borderRadius = '0.25rem',
  count = 1,
  className = '',
}) => {
  const skeletonItems = Array.from({ length: count }).map((_, index) => (
    <span
      key={index}
      className={cn(
        'bg-grey-10 animate-duration-1000 inline-block animate-pulse',
        className,
      )}
      style={{
        width,
        height,
        borderRadius,
      }}
    />
  ))

  return <>{skeletonItems}</>
}
